import mixpanel from 'mixpanel-browser'
import { userIsOnlyAdmin } from '../authenticationUtils'
import { getEnvironment } from '../environment'
import { useAuth } from '../../components/provider/OIDCProvider'

/** Custom hook to add mixpanel events.
 * Will check the user and only add events for non-civitas admin users.
 */
export default function useMixpanelEvent() {
  const { user } = useAuth()

  function addMixpanelEvent(eventKey: string) {
    if (user && userIsOnlyAdmin(user)) {
      mixpanel.track(eventKey, {
        institution: getEnvironment(),
        appUserId: user.appUserId
      })
    }
  }

  return { addMixpanelEvent }
}
